import { createFileRoute } from '@tanstack/react-router'
import {Container, LoadingOverlay, Tabs, Title} from "@mantine/core"
import OrdersTable from "@components/ordersTable.tsx";
import {useNewOrders} from "@state/server/orders.query.ts";


export const Route = createFileRoute('/_authenticated/orders/_layout/new')({
  component: RouteComponent,
})

function RouteComponent() {
  const {data, isLoading} = useNewOrders()

  return <Tabs.Panel value={"new"}>
    <Container fluid>
      <LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{radius: "sm", blur: 2}} />
      <Title order={2} py={"md"}>Nové objednávky</Title>
      {data && <OrdersTable orders={data}/>}
    </Container>
  </Tabs.Panel>
}
